import angular from 'angular';
import {
  loaderService,
  reportsDataService,
  orgDataService,
  ssDialogService
} from 'app/services';
import {
  alerts,
  actionIcon,
  confirmDialog,
} from 'app/components/global';
import reportSchedules from '../reportSchedules';
import generateReportDialog from '../dialog.generateReportDialog';
import editReportScheduleDialog from '../dialog.editReportScheduleDialog';
import directive from './report-type.directive';
import controller from './report-type.controller';


export default angular.module('app.components.reports.scheduledReports.reportType', [
  loaderService,
  reportsDataService,
  orgDataService,
  ssDialogService,
  alerts,
  actionIcon,
  confirmDialog,
  generateReportDialog,
  editReportScheduleDialog,
  reportSchedules
])
  .directive('srReportType', directive)
  .controller('SRReportTypeController', controller)
  .name;

console.log('app.components.reports.scheduledReports.reportType created');
